import { Edit } from '@mui/icons-material';
import { Box, Button, Hidden, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PREFIX = 'EditButton';

const classes = {
  button: `${PREFIX}-button`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.button}`]: {
    margin: theme.spacing(0),
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[300]}`,
    boxShadow: 'none',
    color: theme.palette.text.primary,
    padding: theme.spacing(0),
    minWidth: '24px',
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
      boxShadow: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '4px 10px',
    },
  },
}));

const EditButton = ({ onClickEdit }) => {
  const { t } = useTranslation('workOrdersTable');
  return (
    <Root>
      <Button
        variant="contained"
        color="primary"
        size="small"
        className={clsx(classes.button, 'button')}
        onClick={onClickEdit}
      >
        <Edit />
        <Hidden smDown>
          <Box ml={1}>
            <Typography variant="button">
              {t('detail.editPopUp.openButtonText')}
            </Typography>
          </Box>
        </Hidden>
      </Button>
    </Root>
  );
};

export default EditButton;
